import { render, staticRenderFns } from "./AppPersonalInfo.vue?vue&type=template&id=bbaaf9f4&scoped=true&"
import script from "./AppPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./AppPersonalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaaf9f4",
  null
  
)

export default component.exports